<template>
  <div class="cart-list-container">
    <div class="list-header">
      <div>#</div>
      <div>商品</div>
      <div>单价</div>
      <div>数量</div>
      <div>小计</div>
      <div style="text-align:center">操作</div>
    </div>
    <div class="cart-list">
      <div
        v-for="(item, index) in cartItems"
        :key="index"
        class="cart-item"
        :class="{ selected: selectedIndex === index }"
        @click="selectItem(index)"
      >
        <div>{{ index + 1 }}</div>
        <div>{{ item.name }}</div>
        <div>¥{{ item.price.toFixed(2) }}</div>
        <div class="qty-group">
          <button class="btn-qty" @click.stop="modifyQty(index, -1)">-</button>
          <span>{{ item.qty }}</span>
          <button class="btn-qty" @click.stop="modifyQty(index, 1)">+</button>
        </div>
        <div>¥{{ (item.price * item.qty).toFixed(2) }}</div>
        <div style="text-align:center">
          <i class="el-icon-circle-close" style="color:red; cursor:pointer; font-size: 1.2rem;" @click.stop="deleteItem(index)"></i>
        </div>
      </div>
      <div v-if="cartItems.length === 0" class="empty-cart">
        购物车为空
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CartList',
  props: {
    cartItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedIndex: -1
    }
  },
  methods: {
    selectItem(index) {
      this.selectedIndex = index
    },
    modifyQty(index, delta) {
      this.$emit('modify-qty', index, delta)
    },
    deleteItem(index) {
      this.$emit('delete-item', index)
    }
  }
}
</script>

<style scoped>
.cart-list-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.list-header {
  display: grid;
  grid-template-columns: 0.5fr 3fr 1fr 1.5fr 1fr 0.5fr;
  padding: 10px 15px;
  background: #e2e8f0;
  font-weight: bold;
  color: #475569;
  font-size: 0.9rem;
}

.cart-list {
  flex: 1;
  overflow-y: auto;
}

.cart-item {
  display: grid;
  grid-template-columns: 0.5fr 3fr 1fr 1.5fr 1fr 0.5fr;
  padding: 15px;
  border-bottom: 1px solid #f1f5f9;
  align-items: center;
  font-size: 1rem;
  cursor: pointer;
}

.cart-item:nth-child(even) {
  background: #f8fafc;
}

.cart-item.selected {
  background: #eff6ff;
  border-left: 4px solid #2563eb;
}

.qty-group {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
}

.btn-qty {
  width: 28px;
  height: 28px;
  border: 1px solid #cbd5e1;
  background: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
}

.btn-qty:hover {
  background: #f1f5f9;
}

.btn-qty:active {
  transform: scale(0.95);
}

.empty-cart {
  text-align: center;
  padding: 50px;
  color: #94a3b8;
  font-size: 1.2rem;
}
</style>

